import React, { useState, useRef } from 'react';
import { Price as CommonPrice } from '../../types/common';
import { PricesContainer, Tooltip } from './style';

export interface PricesDisplayProps {
  prices: CommonPrice[];
  maxWidth?: number;
  maxVisible?: number;
  selectedUnitId?: number;
}

const PricesDisplay: React.FC<PricesDisplayProps> = ({ 
  prices, 
  maxWidth = 200, 
  maxVisible = 3,
  selectedUnitId
}) => {
  const [showTooltip, setShowTooltip] = useState(false);
  const [tooltipPosition, setTooltipPosition] = useState({ x: 0, y: 0 });
  const containerRef = useRef<HTMLDivElement>(null);

  const formatPrice = (price: CommonPrice) => {
    const formattedPrice = new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL'
    }).format(parseFloat(price.price));
    return `${formattedPrice}/${price.unitOfMeasurement?.name || (price as any).UnitOfMeasurement?.name || 'unidade'}`;
  };

  const filteredPrices = selectedUnitId 
    ? prices.filter(price => (price.unitOfMeasurement?.id || (price as any).UnitOfMeasurement?.id) === selectedUnitId)
    : prices;
  
  const displayPrices = filteredPrices.length > 0 ? filteredPrices : prices;

  const allPricesText = displayPrices.map(formatPrice).join('\n');
  
  const visiblePrices = displayPrices.length > maxVisible 
    ? displayPrices.slice(0, maxVisible)
    : displayPrices;
    
  const displayText = visiblePrices.map(formatPrice).join(', ') + 
    (displayPrices.length > maxVisible ? ` e mais ${displayPrices.length - maxVisible}...` : '');

  const shouldShowTooltip = displayPrices.length > maxVisible;

  const handleMouseEnter = (e: React.MouseEvent) => {
    if (shouldShowTooltip && containerRef.current) {
      setTooltipPosition({
        x: e.clientX + 10,
        y: e.clientY - 10
      });
      setShowTooltip(true);
    }
  };

  const handleMouseLeave = () => {
    setShowTooltip(false);
  };

  return (
    <>
      <PricesContainer
        ref={containerRef}
        maxWidth={maxWidth}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
        style={{ cursor: shouldShowTooltip ? 'help' : 'default' }}
      >
        {displayPrices.length > 0 ? displayText : 'Nenhum preço'}
      </PricesContainer>
      {shouldShowTooltip && (
        <Tooltip visible={showTooltip} x={tooltipPosition.x} y={tooltipPosition.y}>
          {allPricesText}
        </Tooltip>
      )}
    </>
  );
};

export default PricesDisplay;
